import React from "react";
import AscendHeader from "../../images/ascend.svg";

function MobileHeader()
{
    return(
        <div className={'mobile-header'}>
            <img src={AscendHeader} alt="Ascend"/>
        </div>
    )
}

export default MobileHeader;
